import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Order} from '../../dto/order';
import {PartnerCounterCompany, PartnerInvoice} from '../../dto/partnerCounter';
import {DataListModel} from '../../models/data-list-model';
import {Company} from '../../dto/company';

@Injectable({
  providedIn: 'root'
})
export class PartnerCounterService {

  readonly apiPath = 'partner-counter/';

  constructor(private http: HttpClient) { }
  getForCompany(companyId: number, year: number, month: number) {
    return this.http.get(this.apiPath + companyId + '/list' + '?year=' + year + '&month=' + month) as Observable<PartnerCounterCompany>;
  }

  getForCompanyInvoicePreview(companyId: number, year: number, month: number): Observable<PartnerInvoice> {
    return this.http.get(this.apiPath + companyId + '/invoice-preview' + '?year=' + year + '&month=' + month) as Observable<PartnerInvoice>;
  }

  getLineItemCodes(): Observable<string[]> {
    return this.http.get(this.apiPath + 'lineitem-codes') as Observable<string[]>;
  }

  createInvoice(companyId: number, invoicePreview: PartnerInvoice, year: number, month: number): Observable<PartnerInvoice> {
    return this.http.put(this.apiPath + companyId + '/invoice' + '?year=' + year + '&month=' + month, invoicePreview) as Observable<PartnerInvoice>;
  }

  getInvoice(companyId: number, invoiceId: number): Observable<PartnerInvoice> {
    return this.http.get(this.apiPath + companyId + '/invoice/' + invoiceId) as Observable<PartnerInvoice>;
  }

  deleteInvoice(companyId: number, invoiceId: number): Observable<any> {
    return this.http.delete(this.apiPath  + companyId + '/invoice/' + invoiceId) as Observable<any>;
  }

  getInvoices(): Observable<PartnerInvoice[]> {
    return this.http.get(this.apiPath + 'invoices') as Observable<PartnerInvoice[]>;
  }

  updateInvoice(companyId: number, invoice: PartnerInvoice): Observable<PartnerInvoice> {
    return this.http.post(this.apiPath + companyId + '/update-invoice', invoice) as Observable<PartnerInvoice>;
  }

  downloadInvoicePdf(invoiceId: number, companyId: number) {
    return this.http.get( this.apiPath + companyId + '/invoice/' + invoiceId + '/pdf', { params: null, responseType: 'blob', observe: 'response' } );
  }
}
